import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import FooterLinks from "../FooterLinks";
import RewardList from "../RewardList";
import TierCarousel from "./Carousel";
import EmptyView from "./EmptyView";
import ErrorView from "./ErrorView";
import LoadingView from "./LoadingView";

const RewardsView: FC = () => {
  const {
    state: { error, currentTier, selectedTier, rewards, tiers },
  } = useRewardCenter();

  const tier = tiers?.find(
    (item) => item.id === (selectedTier ?? currentTier) && item.hasCms,
  );
  if (error) return <ErrorView />;
  if (currentTier == null) return <LoadingView />;

  return (
    <div data-slot="rewards-view" className="flex flex-1 flex-col gap-2.5">
      <TierCarousel />
      {(tier?.rewards?.length || 0) !== 0 ? <RewardList /> : <EmptyView />}
      <FooterLinks />
    </div>
  );
};

export default RewardsView;
